import { render, staticRenderFns } from "./investmentInstitutions.vue?vue&type=template&id=d1fe9df4&"
import script from "./investmentInstitutions.vue?vue&type=script&lang=js&"
export * from "./investmentInstitutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports